class TenantUtils {
    static isAgraga() {
        let tenant = process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE
        if (!tenant || !tenant.length) tenant = 'agraga'
        if (tenant === 'agraga') return true
        return false
    }
    static isNavexel() {
        if (process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'navexel') return true
        return false
    }
    static changeagent(v){
        if(v){
            let ag = "AGRAGA"
            let na = "NAVEXEL"
            if(v.indexOf(ag)!=-1 && TenantUtils.isNavexel()){
                return v.replace(ag,na)
            }
            if(v.indexOf(na)!=-1 && TenantUtils.isAgraga()){
                return v.replace(na,ag)
            }
            return v
        }
        return ""
    }
}
export default TenantUtils